// guest authenticate actions
export const DEMO_ACTION_TYPE = 'DEMO_ACTION_TYPE';
export const AUTH_INIT_GUEST_LOGIN = 'AUTH_INIT_GUEST_LOGIN';
export const ACTIVATE_GUEST = 'ACTIVATE_GUEST';
export const LANGUAGE_CHANGE = 'LANGUAGE_CHANGE';
export const GET_INDEX = 'GET_INDEX';
export const ISLOGIN = 'LOGIN';
export const SERVER_LOGIN = 'SERVER_LOGIN';
